import { useDialog } from '@globals/dialog/useDialogStore'
import Button from '@mui/material/Button'
import { RecognitionFormData } from '@tenant/recognition/RecognitionModal/sendRecognitionView/useSendRecognitionForm'
import { T } from '@transifex/react'
import { ReactNode } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { MOBILE_SEND_RECOGNITION_DRAWER_KEY } from './SendView/MobileRecognitionSendDialog'
import useMobileRecognitionDrawer, {
  MobileRecognitionDrawerView,
} from './useMobileRecognitionDrawer'

const useMobileRecognitionViewActions = (
  form: UseFormReturn<RecognitionFormData>,
): Record<MobileRecognitionDrawerView, ReactNode | undefined> => {
  const { setView, closeDrawer } = useMobileRecognitionDrawer()
  const { openDialog } = useDialog(MOBILE_SEND_RECOGNITION_DRAWER_KEY)

  return {
    [MobileRecognitionDrawerView.DRAFT_AND_SCHEDULED]: (
      <Button
        fullWidth
        id="btnStartNewRecognition"
        variant="contained"
        color="primary"
        onClick={() => setView(MobileRecognitionDrawerView.RECIPIENTS)}>
        <T _str="Start new recognition" />
      </Button>
    ),
    [MobileRecognitionDrawerView.RECIPIENTS]: (
      <Button
        fullWidth
        id="btnNext"
        variant="contained"
        color="primary"
        onClick={async () => {
          const isValid = await form.trigger('sendTo')
          if (isValid) {
            openDialog(MOBILE_SEND_RECOGNITION_DRAWER_KEY)
            closeDrawer()
          }
        }}>
        <T _str="Next" />
      </Button>
    ),
    [MobileRecognitionDrawerView.VISIBILITY]: (
      <Button
        fullWidth
        id="btnSetVisibility"
        variant="contained"
        color="primary"
        onClick={() => closeDrawer()}>
        <T _str="Set" />
      </Button>
    ),
    [MobileRecognitionDrawerView.QUALITIES]: (
      <Button
        fullWidth
        id="btnAddQualities"
        variant="contained"
        color="primary"
        onClick={() => closeDrawer()}>
        <T _str="Add" />
      </Button>
    ),
    [MobileRecognitionDrawerView.POINTS]: (
      <Button
        fullWidth
        id="btnAddPoints"
        variant="contained"
        color="primary"
        onClick={() => closeDrawer()}>
        <T _str="Add" />
      </Button>
    ),
    [MobileRecognitionDrawerView.SCHEDULE]: (
      <Button
        fullWidth
        id="btnScheduleRecognition"
        variant="contained"
        color="primary"
        onClick={() => closeDrawer()}>
        <T _str="Schedule" />
      </Button>
    ),
    [MobileRecognitionDrawerView.POINTS_EXCEPTION]: (
      <Button
        fullWidth
        id="btnBack"
        variant="contained"
        color="primary"
        onClick={() => closeDrawer()}>
        <T _str="Back" />
      </Button>
    ),
  }
}

export default useMobileRecognitionViewActions
